import { IncomingMessage } from 'http'
import getConfig from 'next/config'

import { getIPAddress as getIPAddressHelper } from '@nx/helpers'

export const getIPAddress = (
  req: IncomingMessage | undefined
): string | undefined => {
  const { serverRuntimeConfig } = getConfig()

  return serverRuntimeConfig['IP_OVERRIDE'] || getIPAddressHelper(req)
}
